function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightArrow = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _SVG = require("../../SVG");
var _styles = require("../../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["size", "color", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var RightArrow = exports.RightArrow = (0, _react.memo)(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? (0, _styles.getREM)(1.0625) : _ref$size,
    color = _ref.color,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors;
  return (0, _jsxRuntime.jsx)(_SVG.SVG.Svg, Object.assign({
    testID: "RightArrow",
    viewBox: "0.2044 0.4923 12.59 15.98",
    fill: "none",
    style: [{
      width: size,
      height: size,
      transform: [{
        rotate: '-90deg'
      }]
    }, style],
    title: "right arrow icon"
  }, props, {
    children: (0, _jsxRuntime.jsx)(_SVG.SVG.Path, {
      d: "M 7.3519 16.1151 L 12.4434 11.0236 C 12.9126 10.5543 12.9122 9.7953 12.4434 9.3264 C 11.9745 8.8576 11.215 8.8576 10.7462 9.3264 L 7.6921 12.3805 L 7.6909 1.6828 C 7.6909 1.0269 7.1567 0.4927 6.5003 0.4923 C 5.8439 0.4919 5.3085 1.0273 5.3085 1.6841 L 5.3064 12.3826 L 2.2532 9.3294 C 1.7839 8.8601 1.0248 8.8606 0.556 9.3294 C 0.0872 9.7983 0.0872 10.5577 0.556 11.0266 L 5.6475 16.1181 C 6.1155 16.586 6.8826 16.5844 7.3519 16.1151 Z",
      fill: color != null ? color : colors.text
    })
  }));
});